import React, { useState } from 'react';
import { PayPalScriptProvider, PayPalButtons } from '@paypal/react-paypal-js';
import { toast } from 'sonner';
import axios from 'axios';
import { API } from '../App';

const PayPalButton = ({ amount, description, rideId, packageType, onSuccess, onError }) => {
  const [loading, setLoading] = useState(false);

  const initialOptions = {
    clientId: process.env.REACT_APP_PAYPAL_CLIENT_ID,
    currency: "USD",
    intent: "capture",
    disableFunding: "credit,paylater",  // Disable Pay Later and PayPal Credit
  };

  const createOrder = async () => {
    try {
      setLoading(true);
      const response = await axios.post(`${API}/paypal/create-order`, {
        amount: parseFloat(amount),
        description: description,
        ride_id: rideId,
        package_type: packageType
      });
      
      // Redirect to PayPal for approval
      if (response.data.approval_url) {
        window.location.href = response.data.approval_url;
      }
      
      return response.data.id;
    } catch (error) {
      console.error('Failed to create PayPal order:', error);
      toast.error('Failed to create payment. Please try again.');
      if (onError) onError(error);
      throw error;
    } finally {
      setLoading(false);
    }
  };

  const onApprove = async (data) => {
    try {
      setLoading(true);
      const response = await axios.post(`${API}/paypal/execute-payment`, null, {
        params: {
          payment_id: data.orderID,
          payer_id: data.payerID
        }
      });
      
      toast.success('Payment completed successfully!');
      if (onSuccess) {
        onSuccess(response.data);
      }
    } catch (error) {
      console.error('Failed to complete PayPal payment:', error);
      toast.error('Payment failed. Please try again.');
      if (onError) onError(error);
    } finally {
      setLoading(false);
    }
  };

  const onCancel = () => {
    toast.info('Payment cancelled');
    if (onError) onError(new Error('Payment cancelled by user'));
  };

  const onErrorHandler = (err) => {
    console.error('PayPal error:', err);
    toast.error('Payment error. Please try again.');
    if (onError) onError(err);
  };

  return (
    <div className="paypal-button-container">
      <PayPalScriptProvider options={initialOptions}>
        <PayPalButtons
          style={{
            layout: 'vertical',
            color: 'blue',
            shape: 'rect',
            label: 'pay'
          }}
          fundingSource="paypal"
          disabled={loading}
          createOrder={createOrder}
          onApprove={onApprove}
          onCancel={onCancel}
          onError={onErrorHandler}
        />
      </PayPalScriptProvider>
      {loading && (
        <div className="text-center text-gray-600 mt-2">
          Processing payment...
        </div>
      )}
    </div>
  );
};

export default PayPalButton;
